jQuery(function($){
  var $hamburger = $('.mobile-site-header__menu .hamburger-menu');
  var $drawer = $('.mobile-site-header__menu .mobile-menu-drawer');
  var $overlay = $('.mobile-site-header__menu .mobile-menu-overlay');

  $hamburger.on('click', function(){
    $(this).toggleClass('active');
    $drawer.toggleClass('active');
    $overlay.toggleClass('active');
    $('.mobile-site-header__menu .mobilebothsidemenu').addClass('active');
  });

  $overlay.on('click', function(){
    $hamburger.removeClass('active');
    $drawer.removeClass('active');
    $overlay.removeClass('active');
    $('.mobile-site-header__menu ul').removeClass('active');
  });

  $(document).on('click', '.mobile-site-header__menu .site-nav__item > a > i.fa', function(e){
    if ($(this).parent('a').siblings('.submenu-collections').length) {
      e.preventDefault();
      $(this).parent('a').siblings('.submenu-collections').addClass('active');
    }
  });

  $(document).on('click', '.mobile-site-header__menu .submenu-collections-list.has-sub > a > i.fa', function(e){
    if ($(this).parent('a').siblings('.sub-submenu-collections').length) {
      e.preventDefault();
      $(this).parent('a').toggleClass('active');
      $(this).parent('a').siblings('.sub-submenu-collections').stop().slideToggle();
    }
  });

  $(document).on('click', '.mobile-site-header__menu .back-link a', function(e){
    e.preventDefault();
    $(this).closest('ul').removeClass('active');
  });

  $(document).on('click', '#alter_menutoggle', function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $('header.header--middle-center-bothside-menu').find('summary.header__icon--menu').trigger('click');
  });
  

  function adjustMenuPosition(){
    var headerHeight = $('.header-wrapper').outerHeight();
    $('.mobile-site-header__menu .mobile-menu-drawer, .mobile-site-header__menu .mobile-menu-overlay')
      .css('top', headerHeight + 'px')
      .css('height', 'calc(100% - ' + headerHeight + 'px)');
  }

  adjustMenuPosition();
  $(window).on('resize', adjustMenuPosition);
});


// Search Script start

const input = document.getElementById("search-input");
const collection = document.getElementById("collection-filter");
const results = document.getElementById("results");
const searchBtn = document.getElementById("search-btn");

let timer;

// Live search while typing
input?.addEventListener("input", () => {
    clearTimeout(timer);
    timer = setTimeout(loadProducts, 300);
});

// Search on category change
collection?.addEventListener("change", loadProducts);

// Search button click
searchBtn?.addEventListener("click", redirectToSearch);

// Search on Enter key
input?.addEventListener("keypress", (e)=>{
    if(e.key==="Enter"){
        redirectToSearch();
    }
});

async function loadProducts(){

       const query = input.value.trim();
    const selectedCollection = collection.value;

    if (!query) {
        results.innerHTML = "";
        results.style.display = "none";
        return;
    }

    try {

        results.style.display = "block";

        const res = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(query)}
            &resources[type]=product
            &resources[limit]=5
            &resources[options][fields]=title,body,product_type,tag,variants.sku
            &resources[options][unavailable_products]=hide`
            .replace(/\s+/g, '')
        );

        const data = await res.json();

        let products =
            data?.resources?.results?.products || [];

        // Optional collection filtering
        if (selectedCollection) {

            products = products.filter(product =>
                product.collections?.some(c =>
                    c.handle === selectedCollection
                )
            );

        }

        if (!products.length) {

            results.innerHTML =
                `<p>No products found</p>`;

            return;
        }   

results.innerHTML = `

${products.map(product=>`

    <a href="${product.url}" class="search-item">

        <img
            src="${product.image || ''}"
            alt="${product.title}"
            width="50"
        />

        <div class="search-content">

            <h4>${product.title}</h4>

            <div class="search-meta">
          <small class="price"> $${
                  product.price
                  ? `${product.price}`
                  : ''
              }

              ${
                  product.price_min
                  ? ` ${product.currency || 'USD'}`
                  : ''
              }

          </small>

            </div>

        </div>

    </a>

`).join('')}

<div class="view-all-wrap">

    <a
      href="/search?q=${encodeURIComponent(query)}&options[prefix]=last&collection=${selectedCollection || 'all'}"
      class="view-all-btn"
    >
       View all results for "${query}"
    </a>

</div>

`;

    }
    catch(error){

        console.log("Search Error:", error);

        results.innerHTML=`
            <div class="search-empty">
                Something went wrong
            </div>
        `;
    }
}


// Redirect to Shopify search page
function redirectToSearch(){

    const query = input.value.trim();
    const selectedCollection = collection.value || 'all';

    if(!query) return;

    const url = `/search?q=${encodeURIComponent(query)}&options[prefix]=last&collection=${selectedCollection}`;

    window.location.href = url;
}


// Close dropdown outside click
document.addEventListener("click",(e)=>{

    if(!e.target.closest(".smart-search")){
        results.style.display="none";
    }

});

const clearBtn = document.getElementById("clear-search");

clearBtn?.addEventListener("click", () => {

    input.value = '';

    results.innerHTML = '';

    results.style.display = 'none';

    clearBtn.style.display = 'none';

    input.focus();

});

input?.addEventListener("input",()=>{

    clearBtn.style.display =
        input.value.trim()
        ? "block"
        : "none";

});